// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderRight_container__aBbhn","menuBtn":"HeaderRight_menuBtn__PUJ47","menuBtnIcon":"HeaderRight_menuBtnIcon__uHLDq","badge":"HeaderRight_badge__xIVjv"};